import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import styles from './NeedToUpdateScreen.module.css';
import { ContactUsModal } from '../sideMenu/contactUs/ContactUsModal';
import { CONTACT_US_STEPS } from '../sideMenu/contactUs/contactUs.constants';
import { getContactBrandData } from '../../actions';

const DESCRIPTION_DEFAULT = 'reimbursementCard.title';

const NeedToUpdateScreen = ({
  descriptionI18nKey = '',
  header = '',
  title = '',
}) => {
  const { t } = useTranslation('myAccount');
  const dispatch = useDispatch();
  const [contactUsVisible, setContactUsVisible] = React.useState(false);

  const onContactUsOpen = () => setContactUsVisible(true);

  const onContactUsClose = () => setContactUsVisible(false);

  React.useEffect(() => {
    dispatch(getContactBrandData());
  }, []);

  return (
    <>
      <h3 className={styles.titleHeader}>{header}</h3>

      <div className="Billing-and-payments-container">
        <div className={styles.container}>
          <span className={styles.title}>{title}</span>

          <p className={styles.descriptions}>
            <Trans
              components={{ b: <strong /> }}
              i18nKey={descriptionI18nKey || DESCRIPTION_DEFAULT}
              ns="myAccount"
              t={t}
            />
          </p>

          <button
            className={styles.button}
            onClick={onContactUsOpen}
            type="button"
          >
            {t('contactUs')}
          </button>
        </div>

        <ContactUsModal
          companyStep={CONTACT_US_STEPS}
          onClose={onContactUsClose}
          show={contactUsVisible}
        />
      </div>
    </>
  );
};

export { NeedToUpdateScreen };
